export default "__VITE_ASSET__B7JcPXO3__"